// Webpack Polyfill Injector
function main() {
    require("./src/ui/polyfills");
    require("babel-polyfill");
    require("./src/ui/index.jsx");
}
if (function() {
    return /* Element */ !("Element"in this&&"HTMLElement"in this
) ||
        /* Element.prototype.append */ !("Element"in this&&"append"in Element.prototype
) ||
        /* Element.prototype.cloneNode */ !("document"in this&&"cloneNode"in document.documentElement&&function(){var e=document.createElement("div"),n=document.createElement("input")
n.type="radio",n.checked=!0,e.appendChild(n)
var t,c=n.cloneNode(!1)
try{t=e.cloneNode()}catch(d){return!1}return c.checked&&void 0!==t&&0===t.childNodes.length}()
) ||
        /* Element.prototype.closest */ !("document"in this&&"closest"in document.documentElement
) ||
        /* Element.prototype.dataset */ !((function(){if(!document.documentElement.dataset)return!1
var t=document.createElement("div")
return t.setAttribute("data-a-b","c"),t.dataset&&"c"==t.dataset.aB})()
) ||
        /* Element.prototype.matches */ !("document"in this&&"matches"in document.documentElement
) ||
        /* Element.prototype.placeholder */ !("document"in this&&"placeholder"in document.createElement("input")
) ||
        /* Element.prototype.prepend */ !("Element"in this&&"prepend"in Element.prototype
) ||
        /* Element.prototype.remove */ !("Element"in this&&"remove"in Element.prototype
) ||
        /* Element.prototype.replaceWith */ !("Element"in this&&"replaceWith"in Element.prototype
);
}.call(window)) {
    var js = document.createElement('script');
    js.src = "cdn/js/polyfills.js";
    js.onload = main;
    js.onerror = function onError(message) {
        console.error('Could not load the polyfills: ' + message);
    };
    document.head.appendChild(js);
} else {
    main();
}